import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';
import { getContentLocation } from 'redux/modules/cms-content/selectors';
import { getFeatureFlags } from 'utils/feature-flags';
import { SITE_WIDE_BANNER } from 'constants/experience-fragments';

export const getExperienceFragmentByKey = (state: WtrState, experienceFragmentKey: string) =>
  getStateAtNamespaceKey(state, 'experienceFragments')[experienceFragmentKey];

export const hasExperienceFragmentByKey = (state: WtrState, experienceFragmentKey: string) =>
  !!getExperienceFragmentByKey(state, experienceFragmentKey);

export const getExperienceFragmentLocation = (
  state: WtrState,
  experienceFragmentKey: string,
  location: string,
) => {
  if (
    getFeatureFlags()?.aem_use_content_experience_service &&
    experienceFragmentKey === SITE_WIDE_BANNER.key
  ) {
    const resourcePath = `content/experience-fragments/waitrosegroceriescms/${experienceFragmentKey}`;

    return getContentLocation(state, resourcePath, location);
  }

  const { locations } = getExperienceFragmentByKey(state, experienceFragmentKey) || {};

  return locations?.[location];
};

export const hasExperienceFragmentLocation = (
  state: WtrState,
  experienceFragmentKey: string,
  location: string,
) => !!getExperienceFragmentLocation(state, experienceFragmentKey, location)?.length;

export const getExperienceFragmentPageTitle = (state: WtrState, experienceFragmentKey: string) =>
  getExperienceFragmentByKey(state, experienceFragmentKey)?.pageTitle?.text;

export default getExperienceFragmentLocation;
